import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

import Text from "components/Text";
import Icon from "components/Icon";
import Avatar from "components/Avatar";
import Shadow from "components/Shadow";

import { colors, sizes } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { sn } from "utils";
import { _goToCompanyProfile } from "routers/helper";

const CompanyProfileCard: React.FC = () => {
  const { role, company } = useRecoilValue(authAtom);

  return sn(true, true, false, false) ? (
    <TouchableOpacity
      activeOpacity={sizes.tapOpacity}
      onPress={_goToCompanyProfile}
    >
      <Shadow style={{ ...styles.container, flexDirection: "row" }}>
        <Icon type="ion" name="chevron-back" size={25} />
        <View style={{ flex: 1 }} />
        <View style={{ marginRight: sizes.space }}>
          <Text align="right" weight="extraBold" size={"lg"}>
            {company?.name}
          </Text>
          <Text align="right">{role}</Text>
        </View>
        <View>
          <Avatar size={sn(65, 75, 75, 75)} avatar={{ uri: company.avatar }} />
        </View>
      </Shadow>
    </TouchableOpacity>
  ) : (
    <TouchableOpacity
      style={{ borderWidth: 1 }}
      activeOpacity={sizes.tapOpacity}
      onPress={_goToCompanyProfile}
    >
      <Shadow style={{ ...styles.container }}>
        <Avatar size={sn(65, 75, 75, 75)} avatar={{ uri: company?.avatar }} />
        <View>
          <Text align="center" weight="extraBold" size={"lg"}>
            {company.name}
          </Text>
          <Text align="center">{role}</Text>
        </View>
        <Icon type="ion" name="chevron-back" size={25} />
      </Shadow>
    </TouchableOpacity>
  );
};

export default CompanyProfileCard;

const styles = StyleSheet.create({
  container: {
    width: "100%",
    padding: sizes.space,
    alignItems: "center",
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.white,
  },
});
